import MyBtnConfirm from "Components/MyBtnConfirm/MyBtnConfirm";
import { DeleteOutlined } from "@ant-design/icons";
import { defaultSettings } from "css/defaultAntStyles";
import { formatDate } from "Helpers/formatDate";
import React, { useEffect, useState } from "react";
import { Card, Space } from "antd";
import { MyTitle } from "Components/MyTitle/MyTitle";
import {
  errorNotification,
  successNotification,
} from "Components/MyNotification";
import ProjectApi from "Api/ProjectApi/ProjectApi";
import { MyLoader } from "Components/MyLoader/MyLoader";
import { useDispatch } from "react-redux";
import {
  setBlankId,
  setDrawerLoading,
  setIsFormAfterSave,
} from "AppStore/Slices/BlankSlice/BlankSlice";

export const BlanksList = ({ projectId, isLoading, close }) => {
  const dispatch = useDispatch();
  const [projectBlanks, setProjectBlanks] = useState([]);
  const getSavedBlanksForProject = async (projectId) => {
    try {
      dispatch(setDrawerLoading(true));

      const result = await ProjectApi.getSavedBlanksForProject(projectId);
      if (result.status === "fail") {
        errorNotification(result.message);
        throw result?.message || "Помилка при отриманні бланків";
      }
      setProjectBlanks(result.dto);
    } catch (err) {
      errorNotification(err.message);
    } finally {
      dispatch(setDrawerLoading(false));
    }
  };
  const handleDeleteBlank = async (blankId, projectId) => {
    try {
      dispatch(setDrawerLoading(true));

      const result = await ProjectApi.deleteSavedBlankForProject(
        blankId,
        projectId,
      );
      if (result.status === "fail") {
        errorNotification(result.message);
        throw result?.message || "Помилка при видаленні бланку";
      }
      successNotification("Бланк видалено!");
      await getSavedBlanksForProject(projectId);
    } catch (err) {
      errorNotification(err.message);
    } finally {
      dispatch(setDrawerLoading(false));
    }
  };
  const handleEditBlankOpen = (blankId) => {
    close();
    dispatch(setBlankId(blankId));
    dispatch(setIsFormAfterSave(true));
  };
  useEffect(() => {
    getSavedBlanksForProject(projectId);
  }, []);
  if (isLoading) {
    return <MyLoader centered />;
  }
  return (
    <>
      {projectBlanks.length ? (
        <>
          <MyTitle text={"Мої збережені бланки по проекту"} level={5} />
          <Space direction="vertical" size={12} style={{ width: "100%" }}>
            {projectBlanks.map((elem) => {
              return (
                <Card onClick={() => handleEditBlankOpen(elem.id)}>
                  <div
                    style={{
                      display: "flex",
                      gap: "5px",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      fontSize: "18px",
                    }}
                  >
                    <p>Бланк від {formatDate(elem.createdAt)}</p>
                    <div
                      style={{
                        display: "flex",
                        gap: "15px",
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <MyBtnConfirm
                        btnIcon={
                          <DeleteOutlined
                            style={{ color: defaultSettings.colorPrimary }}
                          />
                        }
                        icon={
                          <DeleteOutlined
                            style={{ color: defaultSettings.colorPrimary }}
                          />
                        }
                        ghost={true}
                        fontSize="20px"
                        type=""
                        mainTitle={`Видалити бланк за ${formatDate(elem.createdAt)}?`}
                        onConfirm={() => {
                          handleDeleteBlank(elem.id, projectId);
                        }}
                      />
                    </div>
                  </div>
                </Card>
              );
            })}
          </Space>
        </>
      ) : (
        <MyTitle text={"Немає збережених бланків по проекту"} level={5} />
      )}
    </>
  );
};
